/**
 * Bolsa.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EstadoSolicitacaoRenovacao = 1 | 2 | 3;

export const EstadoSolicitacaoRenovacao = {
    NUMBER_1: 1 as EstadoSolicitacaoRenovacao,
    NUMBER_2: 2 as EstadoSolicitacaoRenovacao,
    NUMBER_3: 3 as EstadoSolicitacaoRenovacao
};

